import {useEffect, useState} from "react";
import { AppEntities } from "src/config/entities";
import {toast} from "react-toastify";
import { IncomingCashsDto } from "../dtos/IncomingCashsDto";
import { IncomingCashsModel } from "../models/IncomingCashsModel";
import { IncomingCashsPaymentPaymentsDto } from "../dtos/IncomingCashsPaymentPaymentsDto";
import { IncomingCashPaymentService } from "src/services/documents/IncomingCashPaymentService";


interface IProps {
    documentId?: string;
}

export const useFetchIncomingCashPayment = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<IncomingCashsDto | null>(null);
    const [documentModel, setDocumentModel] = useState<IncomingCashsModel | null>(null);
    const dataService = AppEntities.IncomingCashs.getDataService() as IncomingCashPaymentService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: IncomingCashsModel) => {
        if (!documentId) return;
        const requestDto: IncomingCashsDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: IncomingCashsDto | null = null;
            let responsePayments:IncomingCashsPaymentPaymentsDto[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: IncomingCashsDto = {
                ...responseDto,
                payments: [...responsePayments],
         
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}